import React from "react";

type props = {
    color?: string
    background?: string
}
export function Satcom({color = "#01C292", background="#F0FFFA"}: props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" fill={background}/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke={color}/>
            <path
                d="M20.168 13.4512L16.9473 16.6387C16.7812 16.8379 16.5156 16.9707 16.2168 16.9707C15.918 16.9707 15.6523 16.8379 15.4531 16.6387L12.7969
                13.9824L12.4648 14.3145C12.8301 15.1113 13.0293 15.9746 13.0293 16.9043C13.0293 18 12.7637 19.0293 12.2988 19.8926C12.1328 20.1914 11.7344
                20.2246 11.5352 19.9922L7.94922 16.4395L7.35156 17.0039C7.38477 17.1035 7.41797 17.1699 7.41797 17.2695C7.41797 17.8672 6.95312 18.332 6.35547
                18.332C5.75781 18.332 5.29297 17.8672 5.29297 17.2695C5.29297 16.6719 5.75781 16.207 6.35547 16.207C6.45508 16.207 6.52148 16.2402 6.62109
                16.2734L7.18555 15.6758L3.63281 12.0898C3.40039 11.8906 3.43359 11.4922 3.73242 11.3262C4.5957 10.8613 5.625 10.5957 6.6875 10.5957C7.61719
                10.5957 8.51367 10.7949 9.31055 11.1602L9.64258 10.8281L6.98633 8.17188C6.78711 7.97266 6.6543 7.70703 6.6543 7.4082C6.6543 7.10938 6.78711
                6.84375 6.98633 6.67773L10.1738 3.45703C10.373 3.25781 10.6387 3.125 10.9375 3.125C11.2363 3.125 11.502 3.25781 11.7012 3.45703L14.3574
                6.11328L15.9512 4.51953C16.1504 4.32031 16.416 4.1875 16.7148 4.1875C17.0469 4.1875 17.3125 4.32031 17.5117 4.51953L19.1055 6.11328C19.3047
                6.3125 19.4375 6.57812 19.4375 6.87695C19.4375 7.20898 19.3047 7.47461 19.1055 7.67383L17.5117 9.26758L20.168 11.957C20.3672 12.123 20.5 12.3887
                20.5 12.6875C20.5 12.9863 20.3672 13.252 20.168 13.4512ZM10.7715 9.69922L13.2285 7.24219L10.9375 4.95117L8.48047 7.4082L10.7715 9.69922ZM18.6738
                12.6875L16.3828 10.3965L13.9258 12.8535L16.2168 15.1445L18.6738 12.6875Z"
                fill={color}
            />
        </svg>
    );
}